module.exports = __webpack_public_path__ + "static/people_pop2-66b76bfbf8fce21472e624212ee04a3e.png";